var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "acc-list-wrapper" }, [
    _c("div", { staticClass: "small-title" }, [
      _vm._v(_vm._s(_vm.$t("setting.setDefault")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "acc-list __pointer" }, [
      _c("div", { ref: "listWrapper", staticClass: "list-wrapper" }, [
        _c(
          "div",
          { ref: "list" },
          _vm._l(_vm.addrList, function(addrObj, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "acc-item",
                on: {
                  click: function($event) {
                    return _vm.setDefault(addrObj.addr, index)
                  }
                }
              },
              [
                _c("span", {
                  staticClass: "select",
                  class: {
                    active: _vm.defaultAddr === addrObj.address
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "describe __ellipsis" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showNameInput !== index,
                          expression: "showNameInput !== index"
                        }
                      ],
                      staticClass: "bold"
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            addrObj.name ||
                              "" + _vm.$t("addrName", { index: index + 1 })
                          ) +
                          "\n                        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "name-input",
                      attrs: { autocomplete: "off" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showNameInput === index,
                            expression: "showNameInput === index"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.editName,
                            expression: "editName"
                          }
                        ],
                        ref: "nameInput",
                        refInFor: true,
                        attrs: {
                          type: "text",
                          autocomplete: "off",
                          placeholder: index
                        },
                        domProps: { value: _vm.editName },
                        on: {
                          blur: function($event) {
                            return _vm.rename(addrObj.address, index)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.editName = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "__ellipsis" }, [
                    _vm._v(_vm._s(addrObj.address))
                  ])
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "icon __pointer",
                  class: {
                    "not-allowed": !_vm.isLogin && _vm.currHDAcc.isSeparateKey
                  },
                  attrs: { src: require("assets/imgs/edit_default.svg") },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.startRename(addrObj.address, index)
                    }
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "icon __pointer",
                  attrs: { src: require("assets/imgs/copy_default.svg") },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.copy(addrObj.address)
                    }
                  }
                })
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.isLogin &&
                _vm.addrList.length < 10 &&
                !_vm.currHDAcc.isSeparateKey,
              expression:
                "isLogin && addrList.length < 10&&!currHDAcc.isSeparateKey"
            }
          ],
          staticClass: "add",
          on: { click: _vm.addAddr }
        },
        [
          _c("span", { staticClass: "acc-add" }),
          _c("span", { staticClass: "describe bold" }, [
            _vm._v(_vm._s(_vm.$t("setting.addAddr")))
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }